const sidenav = {
  abandonedCallsBadge: 'MainLayout-Sidenav-AbandonedCallsBadge',
  secondChanceLeadsBadge: 'MainLayout-Sidenav-SecondChanceLeadsBadge',
  vaFollowUpsBadge: 'MainLayout-Sidenav-VaFollowUpsBadge',
  inboxPageNavButton: 'MainLayout-Sidenav-InboxPageNavButton',
  userManagementPageNavBtn: 'MainLayout-Sidenav-UserManagementPageNavButton',
  virtualAgentSettingPageNavBtn:
    'MainLayout-Sidenav-VirtualAgentSettingsPageNavButton',
  workflowManagementPageNavBtn:
    'MainLayout-Sidenav-WorkflowManagementPageNavButton',
  queueManagementPageNavBtn: 'MainLayout-Sidenav-QueueManagementPageNavButton',
  conversationHistoryPageNavBtn:
    'MainLayout-Sidenav-ConversationHistoryPageNavButton',
  abandonedCallsPageNavBtn:
    'MainLayout-Sidenav-UrgentFollowUps-AbandonedCallsPageNavButton',
  secondChanceLeadsPageNavBtn:
    'MainLayout-Sidenav-UrgentFollowUps-SecondChanceLeadsPageNavButton',
  voicemailsPageNavBtn:
    'MainLayout-Sidenav-UrgentFollowUps-VoicemailsPageNavButton',
  virtualAgentsCallsPageNavBtn:
    'MainLayout-Sidenav-UrgentFollowUps-VirtualAgentsCallsPageNavButton',
  queueMonitoringPageNavBtn: 'MainLayout-Sidenav-QueueMonitoringPageNavButton',
  callCenterMonitoringPageNavBtn:
    'MainLayout-Sidenav-CallCenterMonitoringPageNavButton',
  presetDaysTimesPageNavBtn: 'MainLayout-Sidenav-PresetDaysTimesPageNavButton',
  transferRecordingPageNavBtn:
    'MainLayout-Sidenav-TransferRecordingPageNavButton',
  callContinuityPageNavBtn: 'MainLayout-Sidenav-CallContinuityPageNavButton',
  globalRecordingPageNavBtn:
    'MainLayout-Sidenav-GlobalRecordingDefaultsPageNavButton',
  individualRecordingPageNavBtn:
    'MainLayout-Sidenav-IndividualRecordingPageNavButton',
  queueRecordingPageNavBtn: 'MainLayout-Sidenav-QueueRecordingPageNavButton',
  exclusionListPageNavBtn: 'MainLayout-Sidenav-ExclusionListPageNavButton',
  callAnalysisPageNavBtn: 'MainLayout-Sidenav-CallAnalysisPageNavButton',
  dataIntegrationPageNavBtn: 'MainLayout-Sidenav-DataIntegrationPageNavButton',
  inboxTaskCardsPageNavBtn: 'MainLayout-Sidenav-InboxTaskCardsPageNavButton',
} as const;

const outboundAndTransferModal = {
  employeeRowRadioBtn: 'Layout-OutboundAndTransferModal-EmployeeRowRadioBtn',
  technicianRowRadioBtn:
    'Layout-OutboundAndTransferModal-TechnicianRowRadioBtn',
  keypadBtn: 'Layout-OutboundAndTransferModal-KeypadBtn',
  primaryActionBtn: 'Layout-OutboundAndTransferModal-PrimaryActionBtn',
  secondaryActionBtn: 'Layout-OutboundAndTransferModal-SecondaryActionBtn',
  keypadInput: 'Layout-OutboundAndTransferModal-KeypadInput',
  technicianCallBtn:
    'Layout-OutboundAndTransferModal-TechnicianConfirmationModal-CallButton',
} as const;

const outboundCallerIdModal = {
  numberRowRadioBtn: 'Layout-OutboundCallerIdModal-NumberRadioButtonCell',
} as const;

const navBar = {
  disconnectButton: 'MainLayout-NavBar-DisconnectButton',
  reconnectButton: 'MainLayout-NavBar-ReconnectButton',
  logo: 'MainLayout-NavBar-Logo',
  title: 'MainLayout-NavBar-Title',
  userStatusMenu: 'MainLayout-NavBar-UserStatusMenu',
  userStatusMenuOption: 'MainLayout-NavBar-UserStatusMenuOption',
  settingsBtn: 'Layout-NavBar-SettingsBtn',
  managerAssistBtn: 'Layout-NavBar-ManagerAssistBtn',
  callBtnIcon: 'Inbox-CallBar-CallButtonIcon',
  helpCenterBtn: 'Layout-NavBar-HelpCenterBtn',
  resetAccountBtn: 'MainLayout-NavBar-ResetAccountBtn',
} as const;

const userMenu = {
  openButton: 'MainLayout-Navbar-UserMenu-ActionMenu',
  userNameLabel: 'MainLayout-Navbar-UserMenu-UserName',
  refreshStatusButton: 'MainLayout-Navbar-UserMenu-RefreshStatusButton',
} as const;

const resetAccountModal = {
  dialog: 'MainLayout-ResetAccountModal-Dialog',
  acknowledgementCheckbox:
    'MainLayout-ResetAccountModal-AcknowledgementCheckbox',
  keepTasksRadio: 'MainLayout-ResetAccountModal-KeepTasksRadio',
  clearTasksRadio: 'MainLayout-ResetAccountModal-ClearTasksRadio',
  resetButton: 'MainLayout-ResetAccountModal-ResetButton',
  cancelButton: 'MainLayout-ResetAccountModal-CancelButton',
} as const;

const toastGroup = {
  toast: 'Layout-ToastGroup-Toast',
};

export const mainLayoutLocators = {
  sidenav,
  navBar,
  toastGroup,
  outboundAndTransferModal,
  userMenu,
  resetAccountModal,
  outboundCallerIdModal,
} as const;
